import Vue from "vue";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import VueIziToast from "vue-izitoast";
import "bootstrap/dist/css/bootstrap.css";
import "izitoast/dist/css/iziToast.min.css";
import "jquery/dist/jquery.js";
import "popper.js/dist/umd/popper.js";
import store from "./store";
import router from "./router";
import App from "./App.vue";
import "./helpers/interceptors";
import axios from "axios";
import "./css/sb-admin.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import vueNumeralFilterInstaller from "vue-numeral-filter";

Vue.component("date-picker", VuePersianDatetimePicker);
Vue.use(BootstrapVue);
Vue.use(VueIziToast);
Vue.use(require("vue-moment"));
// Vue.use(vueNumeralFilterInstaller, { locale: 'en-gb' });
// Show table/grid | numeral('0,0') .
Vue.use(vueNumeralFilterInstaller, { locale: "vi" });

// GLOBAL VARIABLE
// Vue.prototype.$admin_account = "admin";
Vue.prototype.$booking_account = "AD001";
Vue.prototype.$tinhtranghoso_nghiviec = 67;
Vue.prototype.$project_manager = 2229;
//#region
Vue.prototype.$employee_status_on_working = 66;
Vue.prototype.$employee_status_leave = 67;
Vue.prototype.$employee_status_probation;
Vue.prototype.$employee_status_retire = 69;
Vue.prototype.$employee_status_intern = 2233;
Vue.prototype.$employee_status_collaborator = 20303;
//#endregion

//#region Time-Off status
Vue.prototype.$timeoff_type_paidleave = 63;
Vue.prototype.$timeoff_type_unpaidleave = 65;
Vue.prototype.$timeoff_type_workfromhome = 25348;
Vue.prototype.$timeoff_type_statutoryleave = 25364;
//#endregion

//#region Time-Off type
Vue.prototype.$timeoff_status_awaiting_approval = 0;
Vue.prototype.$timeoff_status_approved = 1;
Vue.prototype.$timeoff_status_declined = 2;
//#endregion

//#region Requirement type
Vue.prototype.$requirement_type_playback = 20327;
Vue.prototype.$requirement_type_playback_livestream = 20328;
//#endregion

Vue.prototype.$qtakecosttype_salary = 6250;
Vue.prototype.$meeting_van16 = 8;
Vue.prototype.$meeting_testCovid = 2018;
Vue.prototype.$date_format_regex = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/; // Check for date:[dd/mm/yyyy] format
Vue.prototype.$email_format_regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // Check for email format

//#region *GLOBAL FUNCTION*
//#region CONVERT DATETIME
//#region STRING TO DATETIME
Vue.prototype.$convert_string_date = function(date) {
  if (date == null || date == "") return null;

  var date_split = date.split("/");
  var new_date = new Date(
    parseInt(date_split[2]),
    parseInt(date_split[1]) - 1,
    parseInt(date_split[0])
  );

  if (new_date == "Invalid Date") return null;

  return new_date;
};

Vue.prototype.$convert_string_date_special = function(date) {
  if (date == null || date == "") return null;

  var date_split = date.split("/");
  var new_date = new Date(
    parseInt(date_split[2]),
    parseInt(date_split[1]) - 1,
    parseInt(date_split[0]) + 1
  );

  if (new_date == "Invalid Date") return null;

  return new_date;
}; //Pitch Sale Module

Vue.prototype.$convert_string_GMT7_DateTime = function(dateString) {
  if (dateString == null || dateString == "") return null;

  var DT_split = "";
  if (dateString.includes("/")) {
    DT_split = dateString.split("/");
  } else if (dateString.includes("-")) {
    DT_split = dateString.split("-");
  }

  if (DT_split == null || DT_split == "") return null;

  var new_date = new Date(
    `${parseInt(DT_split[1])}
     ${parseInt(DT_split[0])},
     ${parseInt(DT_split[2])}, 00:00:00 GMT+7:00`
  );

  if (new_date == "Invalid Date") return null;

  return new_date;
};
//#endregion STRING TO DATETIME

//#region DATETIME TO STRING
Vue.prototype.$convert_date_string = function(date) {
  if (date == null) return null;
  return this.$moment(date)
    .format("DD/MM/YYYY")
    .toString();
};

Vue.prototype.$formatDateToDDMMYYYY = function(date) {
  // Ensure 'date' is a valid Date object
  if (typeof date === "string") {
    date = new Date(date);
  } //Bonus Module

  // Get day, month, and year components from the Date object
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const year = date.getFullYear();

  // Return the formatted string
  return `${day}/${month}/${year}`;
};

Vue.prototype.$convert_date_string_master = function(date) {
  if (date == null) return null;
  return this.$moment(date)
    .format("MMMM YYYY")
    .toString();
}; //Master Schedule Module
//#endregion DATETIME TO STRING

//#region CONVERT STRING FORMAT
Vue.prototype.$swap_date_format = function(date) {
  if (date == null) return "";
  var date_split = date.split("/");
  return date_split[2] + "-" + date_split[1] + "-" + date_split[0];
};

Vue.prototype.$swap_date_format_2 = function(date) {
  var date_split = date.split("/");
  return date_split[2] + "/" + date_split[1] + "/" + date_split[0];
};
//#endregion CONVERT STRING FORMAT
//#endregion CONVERT DATETIME

Vue.prototype.$insert_array_parse_json = function(record, array, _index = -1) {
  var index = -1;
  if (_index == -1) index = array.findIndex((x) => x.id == record.id);
  else index = _index;

  array[index] = JSON.parse(JSON.stringify(record));
  const temp = JSON.parse(JSON.stringify(array));
  array = JSON.parse(JSON.stringify(temp));

  return array;
};

Vue.prototype.$sort_order_list = function(array, param, reverse) {
  var filterA, filterB;
  return array.sort(function(a, b) {
    switch (param) {
      case "sortOrder":
        filterA = a.sortOrder;
        filterB = b.sortOrder;
        break;
    }
    if (reverse) {
      return filterA > filterB ? 1 : -1;
    } else {
      return filterA < filterB ? 1 : -1;
    }
  });
};

Vue.prototype.$download_excel_file = function(_source) {
  let filename = _source.headers["content-disposition"]
    .split(";")
    .find(function(el) {
      if (el.includes("filename=")) return el;
    })
    .replace("filename=", "")
    .replace(/"/g, "")
    .trim();
  const url = window.URL.createObjectURL(
    new Blob([_source.data], { type: "application/vnd.ms-excel;charset=utf-8" })
  );
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
};

Vue.prototype.$download_pdf_file = function(_source) {
  let filename = _source.headers["content-disposition"]
    .split(";")
    .find(function(el) {
      if (el.includes("filename=")) return el;
    })
    .replace("filename=", "")
    .replace(/"/g, "")
    .trim();
  const url = window.URL.createObjectURL(
    new Blob([_source.data], { type: "application/pdf;charset=utf-8" })
  );
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
};

Vue.prototype.$copy = function(_object) {
  if (Array.isArray(_object)) {
    return Object.assign([], _object);
  }
  return Object.assign({}, _object);
};

Vue.prototype.$success_message = function(
  message,
  eng = false,
  _timeout = 3000
) {
  if (eng) this.$toast.success(message, "Success", { timeout: _timeout });
  else this.$toast.success(message, "Thành công", { timeout: _timeout });
};

Vue.prototype.$error_message = function(message, eng = false, _timeout = 3000) {
  if (eng) this.$toast.error(message, "Error", { timeout: _timeout });
  else this.$toast.error(message, "Lỗi", { timeout: _timeout });
};
//#endregion GLOBAL FUNCTION

// DEBUGGING FUNCTION
Vue.prototype.$log = function(data) {
  // eslint-disable-next-line no-console
  console.log(data);
};

const initialStore = localStorage.getItem("store");

if (initialStore) {
  store.commit("initialise", JSON.parse(initialStore));
  if (store.getters.isAuthenticated) {
    axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${store.state.auth.accessToken}`;
  }
}

new Vue({
  render: (h) => h(App),
  router,
  store,
}).$mount("#app");
